import styled from "styled-components";
import { Icons } from "../../utils/react-svg";

const Sparkle = styled(Icons.Sparkle)`
  path {
    stroke: var(--indigo-blue);
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1_5);
  align-items: center;
  text-align: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0_75);
`;

const FlyoutCartQuizEntry = () => (
  <Wrapper className="vertical-center">
    <Sparkle width="40" height="40" />
    <Content>
      <div className="typography-eyebrow1">Need some help?</div>
      <div className="typography-lead1">
        Take our quiz. Get a personalized Ritual.
      </div>
      <div className="typography-body1">
        Get a nutritionist developed recommendation, in just a couple of clicks.
      </div>
    </Content>
  </Wrapper>
);

export default FlyoutCartQuizEntry;
